function validate(cpf: string) {
  if (cpf.length != 11
    || cpf == "00000000000"
    || cpf == "11111111111"
    || cpf == "22222222222"
    || cpf == "33333333333"
    || cpf == "44444444444"
    || cpf == "55555555555"
    || cpf == "66666666666"
    || cpf == "77777777777"
    || cpf == "88888888888"
    || cpf == "99999999999"
  ) {
    return false;
  }

  const numeros = cpf.match(/\d/g)!.map(Number);

  let soma = numeros.reduce((acc, cur, idx) => {
    if (idx < 9) {
      return acc + cur * (10 - idx);
    }
    return acc;
  }, 0);

  let resto = (soma * 10) % 11;

  if (resto === 10 || resto === 11) {
    resto = 0;
  }

  if (resto !== numeros[9]) {
    return false;
  }

  soma = numeros.reduce((acc, cur, idx) => {
    if (idx < 10) {
      return acc + cur * (11 - idx);
    }
    return acc;
  }, 0);

  resto = (soma * 10) % 11;

  if (resto === 10 || resto === 11) {
    resto = 0;
  }

  if (resto !== numeros[10]) {
    return false;
  }

  return true;
}

const cpfValidator = {
  validate,
}

export default cpfValidator;
